import React from 'react';
import PropTypes from 'prop-types';
import CustomSelect from '../FormInputs/CustomSelect/CustomSelect';
import Multiselect from '../FormInputs/Multiselect/Multiselect';
import TextArea from '../FormInputs/TextArea/TextArea';
import DateSelectorV2 from '../FormInputs/DateSelectorV2/DateSelectorV2';
import TextInput from '../FormInputs/TextInput/TextInput';
import Number from '../FormInputs/Number/Number';
import { VALID_TYPES } from '../../utils/customFieldsUtils';

const PreviewInModal = ({
  selectedType = null, label, options, setSelectedDate, numberValue = '', setNumberValue, fieldData = {},
}) => {
  // Define default options based on selected field type
  const defaultOptionsMapping = {
    'FormItem::Multiselect': ['Option 1', 'Option 2', 'Option 3'],
    'FormItem::Select': [],
  };

  const optionPreview = options && options.length > 0 && options[0] !== '' ? options : defaultOptionsMapping[selectedType?.value] || [];
  const fieldDataOptions = fieldData?.options || [];
  const optionDisplay = fieldDataOptions.length > 0 ? [...optionPreview] : optionPreview;

  // Define padding classes for different field types
  const paddingClasses = {
    'FormItem::Multiselect': 'py-0',
    'Multi-select': 'py-0',
    'FormItem::Text': 'py-4.25',
    Text: 'py-4.25',
  };
  const paddingClass = paddingClasses[selectedType?.value] || 'py-10';

  // Define field type components mapping
  const fieldTypeComponents = {
    'FormItem::Select': (
      <div className="w-88.5">
        <CustomSelect
          placeholder="select"
          inputHeight="40"
          options={optionDisplay.map(option => ({ label: option, value: option }))}
        />
      </div>
    ),
    'FormItem::Multiselect': (
      <Multiselect
        options={optionDisplay.filter(option => option.trim() !== '').map(option => ({
          label: option,
          value: option,
        }))}
        labelMarginLeftRight="mx-3"
        labelMarginTopBottom="my-1.5"
        textSize="text-sm font-normal"
      />
    ),
    'FormItem::Text': (
      <TextArea
        name="customTextArea"
        placeholder="enter text"
        className="!w-88.5 !h-22 py-1.5 px-3 !mt-0"
      />
    ),
    'FormItem::Date': (
      <div className="relative">
        <DateSelectorV2
          name="customDate"
          className="!w-88.5 !h-10 !py-1.5 !px-3 appearance-none bg-none"
          dateIconStyles={{
            position: 'absolute',
            top: '50%',
            right: 3,
            transform: 'translateY(-50%)',
          }}
          placeholder="select a date"
          disabled
          value={null}
          setValue={setSelectedDate}
        />
      </div>
    ),
    'FormItem::Line': (
      <TextInput
        name="customText"
        placeholder="enter short text"
        className="!text-vamos-gray !h-10 py-1.5"
        customWidth="w-88.5"
      />
    ),
    'FormItem::Number': (
      <Number
        name="customNumber"
        placeholder="enter number"
        className="!h-10"
        customWidth="w-88.5"
        value={numberValue}
        setValue={setNumberValue}
      />
    ),
  };

  const FieldPreview = fieldTypeComponents[selectedType?.value] || null;

  return (
    <div>
      <h2 className="font-bold text-lg text-left my-4">Preview</h2>

      {/* Heading Preview */}
      {(selectedType?.value === 'FormItem::Heading' || selectedType === 'Heading') && (
        <div className="text-center">
          <h3 className="text-lg font-bold py-12.5">
            {label || 'LABEL'}
          </h3>
        </div>
      )}

      {/* Default Message if No Type is Selected */}
      {!selectedType && (
        <div className="w-full flex justify-center py-12.5">
          <p className="text-base text-vamos-gray text-center">
            preview will appear here once a field type is selected
          </p>
        </div>
      )}

      {/* Render Field Preview */}
      {VALID_TYPES.includes(selectedType?.value || selectedType) && FieldPreview && (
      <div className={`flex flex-row justify-center items-start text-center gap-4 ${paddingClass}`}>
        <h3 className="text-base text-vamos-gray mt-1">
          {label || 'LABEL'}
        </h3>
        <div className="flex flex-col items-start gap-2">
          {FieldPreview}
        </div>
      </div>
      )}
    </div>
  );
};

PreviewInModal.propTypes = {
  selectedType: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  numberValue: PropTypes.string,
  setNumberValue: PropTypes.func.isRequired,
  fieldData: PropTypes.object,
};

export default PreviewInModal;
